module.exports = __webpack_public_path__ + "static/sales-page-background-02-orig-fc3722ae8d7ec489f63f686d8c68d63b.jpg";